import CategorySections from '@app/components/apps/ProductRegistration/ProdRegForms/AllPRCategories';
import { BaseBreadcrumb } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { useHeader } from '@app/components/header/layouts/HeaderContext';

import { Row, Col } from 'antd';
import { useEffect } from 'react';

const PRCategoriesPage = () => {
  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  useEffect(() => {
    setBreadcrumb(
      <BaseBreadcrumb
        routes={[
          {
            path: '/pr-categories',
            breadcrumbName: 'Product Registration Categories',
          },
        ]}
        style={{ marginBottom: '15px' }}
      />,
    );

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons]);

  return (
    <>
      <PageTitle>{'Product Registration Categories'}</PageTitle>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <CategorySections />
        </Col>
      </Row>
    </>
  );
};

export default PRCategoriesPage;
